// First, before bs5-lightbox: that library throws during module evaluation
// under Vite's dev server ("Cannot assign to property 'Lightbox'"), and an
// ESM eval error kills every import that follows it. The recorder feeds the
// homepage's "Pick up where you left off" strip and must not die with it.
import '~/javascripts/recently_viewed.js'

import 'video.js'
import 'video.js/dist/video-js.css'

import Lightbox from 'bs5-lightbox'

// Initialize Lightbox for all elements with data-toggle="lightbox"
document.addEventListener('DOMContentLoaded', () => {
  const lightboxElements = document.querySelectorAll('[data-toggle="lightbox"]');
  lightboxElements.forEach(element => {
    new Lightbox(element);
  });
});
import '~/javascripts/bookings.js'
import '~/javascripts/reviews.js'
import '~/javascripts/maps.js'

// One-off celebration on the booking-confirmed page. Dynamically imported so
// the confetti code never loads on the rest of the booking flow; skipped
// entirely under prefers-reduced-motion. The canvas fades out before removal.
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('[data-booking-celebration]')) return
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  import('~/javascripts/article-interactions/embedded-content/confetti.js')
    .then(({ startConfetti, stopConfetti }) => {
      startConfetti()
      setTimeout(() => {
        const canvas = document.getElementById('article-confetti-canvas')
        if (canvas) {
          canvas.style.transition = 'opacity 600ms ease'
          canvas.style.opacity = '0'
        }
        setTimeout(stopConfetti, 600)
      }, 3200)
    })
    .catch(() => {})
})
